/* src/app/features/player/components/player-controls/components/player-controls-settings/player-controls-settings.scss */
:host {
  position: absolute;
  right: -70px;
  bottom: 40px;
  z-index: 10;
  padding-bottom: 20px;
  transform: translateY(10px);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition:
    opacity 0.25s ease,
    transform 0.25s ease,
    visibility 0.25s ease;
}
.wrapper {
  padding: 25px 25px;
  background-color: var(--background_primary_8);
  border-radius: 15px;
}
.wrapper ul {
  list-style-type: none;
  padding: 0px 25px 0px 25px;
}
.wrapper ul li {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: var(--text_secondary);
  padding: 5px 0px;
  z-index: 2;
  text-transform: capitalize;
}
.wrapper ul li.title,
.wrapper ul li.selected {
  color: var(--text_primary);
}
.wrapper ul li.disabled {
  opacity: 0.4;
  cursor: default;
}
.wrapper ul li .icon {
  position: absolute;
  top: 2.5px;
  left: -25px;
  width: 25px;
  height: 25px;
}
.wrapper ul li .icon img {
  width: 10px;
}
/*# sourceMappingURL=player-controls-settings.css.map */
